/* global ONDEMAND_URL */

import 'whatwg-fetch'; // fetch polyfill

import BaseApi from 'common/api/base';

export default class OndemandApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = ONDEMAND_URL;
    this.defaultParams.credentials = 'same-origin';
  }

  _fetchOld(method, endpoint) {
    const oldBaseUrl = '/api/1/';
    return fetch(`${oldBaseUrl}${endpoint}`, {
      method,
      ...this.defaultParams,
    });
  }

  fetchAgencyAddresses({agencyId}) {
    return this.fetch('GET', `${agencyId}/addresses`);
  }

  fetchRegions({agencyId}) {
    return this.fetch('GET', `${agencyId}/regions`);
  }

  createRide(agencyId, ride) {
    return this.fetch('POST', `${agencyId}/rides`, ride);
  }

  cancelRide(agencyId, rideId) {
    return this.fetch('POST', `${agencyId}/rides/${rideId}/cancel`);
  }

  fetchRideDetails({agencyId, rideId}) {
    return this.fetch('GET', `${agencyId}/rides/${rideId}`);
  }

  fetchServices({agencyId}) {
    return this.fetch('GET', `${agencyId}/services`);
  }

  fetchServiceEstimate({agencyId, serviceId}) {
    return this.fetch('GET', `${agencyId}/services/${serviceId}/estimate`);
  }

  fetchServiceGeometries({agencyId, serviceId}) {
    return this.fetch('GET',
      `${agencyId}/services/${serviceId}/geometry?separate_pickup_dropoff=true`);
  }

  fetchVehiclePosition({agencyId, vehicleId}) {
    return this.fetch('GET', `${agencyId}/vehicles/${vehicleId}/position`);
  }
}



// WEBPACK FOOTER //
// ./src/common/api/OndemandApi.js